import React, { useEffect, useState } from "react";
import axios from "axios";
import {
    Box,
    Button,
    Typography,
    CircularProgress,
    Backdrop
} from "@mui/material";
import { styled } from "@mui/system";
import { useLocation, useParams } from "react-router-dom";
import baseURL from "../../config";

// Modal imports
import COCmodal from "./Modals/COCmodal.jsx";
import SignOnModal from "./Modals/SignOnModal.jsx";
import SignOffModal from "./Modals/SignOffModal.jsx";
import DepartureModal from "./Modals/DepartureModal.jsx";
import FormIModal from "./Modals/FormIModal.jsx";

// Circle button style
const CircleButton = styled(Button)(({ theme }) => ({
    width: 100,
    height: 100,
    borderRadius: "50%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    textTransform: "none",
    fontSize: "1rem",
    fontWeight: "bold",
    boxShadow: theme.shadows[3],
    transition: "0.3s",
    "&:hover": {
        boxShadow: theme.shadows[6],
    },
}));

const SignOnSignOffSection = () => {
    const [formIData, setFormIData] = useState([]);
    const [cocDetails, setCocDetails] = useState([]);
    const [signonDetails, setSignonDetails] = useState([]);
    const [signoffDetails, setSignoffDetails] = useState([]);
    const [departureDetails, setDepartureDetails] = useState([]);
    const [activeModal, setActiveModal] = useState(null);
    const [loading, setLoading] = useState(false);

    const location = useLocation();
    const { id: crewId } = useParams();

    console.log("crewId", crewId)

    // Handle open Form I from navigation state
    useEffect(() => {
        if (location.state?.openFormI) {
            handleFormIClick();
        }
    }, [location.state]);


    // Generic fetch for coc/signOn/signOff/departure
    const fetchStatusByType = async (type, setData, modalKey) => {
        setLoading(true);
        try {
            const token = localStorage.getItem("token");
            if (!token) return console.error("No token found");

            const response = await axios.get(
                `${baseURL}/api/getLatestStatusByCrewIdAndType/${crewId}/${type}`,
                { headers: { Authorization: `Bearer ${token}` } }
            );

            setData(response.data.data || []);
            console.log("signon", response.data.data)
            setActiveModal(modalKey);
        } catch (error) {
            console.error(`Error fetching ${type} data:`, error.response?.data || error.message);
            setData([]);
            setActiveModal(modalKey);
        } finally {
            setLoading(false);
        }
    };

    const handleFormIClick = async () => {
        setLoading(true);
        try {
            const token = localStorage.getItem("token");
            if (!token) return console.error("No token found");

            const response = await axios.get(
                `${baseURL}/api/getContractsWithForm1ByCrewId/${crewId}`,
                { headers: { Authorization: `Bearer ${token}` } }
            );

            setFormIData(response.data?.data || []);
            console.log("response", response.data?.data)
            setActiveModal("formI");
        } catch (error) {
            console.error("Error fetching Form I data:", error.response?.data || error.message);
            setFormIData([]);
            setActiveModal("formI");
        } finally {
            setLoading(false);
        }
    };

    const handleCOCClick = () => fetchStatusByType("coc", setCocDetails, "coc");
    const handleSignOnClick = () => fetchStatusByType("signOn", setSignonDetails, "signOn");
    const handleSignOffClick = () => fetchStatusByType("signOff", setSignoffDetails, "signOff");
    const handleDepartureClick = () => fetchStatusByType("departure", setDepartureDetails, "departure");

    const handleCloseModal = () => setActiveModal(null);

    return (
        <>
            <Box display="flex" flexDirection="column" alignItems="center" gap={3}>
                <Typography variant="h5" fontWeight="bold" gutterBottom>
                    Sign On & Sign Off Actions
                </Typography>

                <Box display="flex" gap={2} flexWrap="wrap" justifyContent="center">
                    <CircleButton
                        variant="contained"
                        color="success"
                        onClick={handleFormIClick}
                        aria-label="Open Form I Modal"
                    >
                        Form I
                    </CircleButton>
                    <CircleButton variant="contained" color="secondary" onClick={handleCOCClick} sx={{ fontSize: "0.75rem" }}>
                        Commencement
                    </CircleButton>
                    <CircleButton variant="contained" color="success" onClick={handleSignOnClick}>
                        Vessel Sign On
                    </CircleButton>
                    <CircleButton variant="contained" color="error" onClick={handleSignOffClick}>
                        Vessel Sign Off
                    </CircleButton>
                    <CircleButton variant="contained" color="info" onClick={handleDepartureClick}>
                        Arrival
                    </CircleButton>
                </Box>
            </Box>

            <hr style={{ visibility: "hidden" }} />

            {/* Full-screen loader */}
            <Backdrop open={loading} sx={{ zIndex: 1300, color: "#fff" }}>
                <CircularProgress color="inherit" />
            </Backdrop>

            {/* Modals */}
            {activeModal === "formI" && (
                <FormIModal open={true} setOpen={handleCloseModal} formIData={formIData} />
            )}
            {activeModal === "coc" && (
                <COCmodal open={true} setOpen={handleCloseModal} cocDetails={cocDetails} />
            )}
            {activeModal === "signOn" && (
                <SignOnModal open={true} setOpen={handleCloseModal} signonDetails={signonDetails} />
            )}
            {activeModal === "signOff" && (
                <SignOffModal open={true} setOpen={handleCloseModal} signoffDetails={signoffDetails} />
            )}
            {activeModal === "departure" && (
                <DepartureModal open={true} setOpen={handleCloseModal} departureDetails={departureDetails} />
            )}
        </>
    );
};

export default SignOnSignOffSection;
